import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CompanyForm, {
  CompanyFormFields,
} from '../../components/Company/CompanyForm';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';
import PersonType from '../../enums/PersonType';

export default function CompaniesNew() {
  const {
    user: { organization },
  } = useAuth();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (data: CompanyFormFields) => {
    try {
      const { alias, ...rest } = data;
      const response = await api.post(
        `organizations/${organization.id}/companies`,
        {
          alias: Number(data.type) === PersonType.Juridical ? alias : undefined,
          ...rest,
        }
      );

      const { id } = response.data;

      navigate(`/companies/${id}/edit`);
    } catch (e: any) {
      if (e?.response?.data?.errors) {
        setFormErrors(e.response.data.errors);
      } else {
        throw e;
      }
    }
  };

  const [formFields, setFormFields] = useState<CompanyFormFields>(
    {} as CompanyFormFields
  );

  return (
    <CompanyForm
      isLoading={1 + 1 === 1}
      title='Nova empresa'
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
